/**
 * Medbook
 * Medbook api
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 */
export interface PickNonNullableStructure107174204417513191811071742044174981918210717420441706819424107174204417034194251071742044024755UndefinedHourRegistrationTypeHourRegistrationValidationCredentialsHourRegistrationValidationHourRegistrationDomains { 
    /**
     * 
     */
    hourRegistrationType?: PickNonNullableStructure107174204417513191811071742044174981918210717420441706819424107174204417034194251071742044024755UndefinedHourRegistrationTypeHourRegistrationValidationCredentialsHourRegistrationValidationHourRegistrationDomains.HourRegistrationTypeEnum;
    /**
     * 
     */
    hourRegistrationValidationCredentials?: Array<string>;
    /**
     * 
     */
    hourRegistrationValidation?: boolean;
    /**
     * 
     */
    hourRegistrationDomains?: boolean;
}
export namespace PickNonNullableStructure107174204417513191811071742044174981918210717420441706819424107174204417034194251071742044024755UndefinedHourRegistrationTypeHourRegistrationValidationCredentialsHourRegistrationValidationHourRegistrationDomains {
    export type HourRegistrationTypeEnum = 'double' | 'single' | 'period' | 'day';
    export const HourRegistrationTypeEnum = {
        Double: 'double' as HourRegistrationTypeEnum,
        Single: 'single' as HourRegistrationTypeEnum,
        Period: 'period' as HourRegistrationTypeEnum,
        Day: 'day' as HourRegistrationTypeEnum
    };
}


